import { UnitInCluster } from 'shared/types/cluster';

/**
 * Column configuration for the cluster units UniversalTable
 */
export const CLUSTER_UNITS_COLUMNS = {
  columns: [
    {
      id: 'unitId',
      label: 'ID',
      sortKey: 'unitId',
      minWidth: 90,
      defaultWeight: 1,
    },
    {
      id: 'referencePlus',
      label: 'Referentie+',
      sortKey: 'referencePlus',
      minWidth: 100,
      defaultWeight: 1,
    },
    {
      id: 'unitType',
      label: 'Type',
      sortKey: 'unitType',
      minWidth: 120,
      defaultWeight: 1,
    },
    {
      id: 'floor',
      label: 'Verdieping',
      sortKey: 'floor',
      minWidth: 80,
      defaultWeight: 0,
    },
    {
      id: 'grossSurface',
      label: 'Bruto m²',
      sortKey: 'grossSurface',
      minWidth: 80,
      defaultWeight: 0,
    },
    {
      id: 'netSurface',
      label: 'Netto m²',
      sortKey: 'netSurface',
      minWidth: 80,
      defaultWeight: 0,
    },
    {
      id: 'building',
      label: 'Gebouw',
      sortKey: 'building',
      minWidth: 200,
      defaultWeight: 3,
    },
    {
      id: 'company',
      label: 'Vennootschap',
      sortKey: 'company',
      minWidth: 150,
      defaultWeight: 2,
    },
    {
      id: 'actions',
      label: '',
      minWidth: 60,
      defaultWeight: 0,
    },
  ],
  localStorageKey: 'cluster-units-table-v3',
};

/**
 * Sort configuration for the cluster units table
 */
export const CLUSTER_UNITS_SORT = {
  defaultSortKey: 'building',
  defaultDirection: 'asc' as const,
  fields: [
    {
      key: 'unitId',
      extractor: (row: UnitInCluster) => row.id,
    },
    {
      key: 'referencePlus',
      extractor: (row: UnitInCluster) => row.referencePlus || '',
    },
    {
      key: 'unitType',
      extractor: (row: UnitInCluster) => row.unitType || '',
    },
    {
      key: 'floor',
      extractor: (row: UnitInCluster) => row.floor ?? -1,
    },
    {
      key: 'grossSurface',
      extractor: (row: UnitInCluster) => row.grossSurface ?? -1,
    },
    {
      key: 'netSurface',
      extractor: (row: UnitInCluster) => row.netSurface ?? -1,
    },
    {
      key: 'building',
      extractor: (row: UnitInCluster) => row.building?.googlePlaceLongAddress || '',
    },
    {
      key: 'company',
      extractor: (row: UnitInCluster) => row.building?.company?.name || '',
    },
  ],
};
